// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComptabilitePrimes_caption__3Mk2N {\n  margin-top: -12px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Comptabilite/ComptabilitePrimes.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","sourcesContent":[".caption {\n  margin-top: -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"caption": "ComptabilitePrimes_caption__3Mk2N"
};
export default ___CSS_LOADER_EXPORT___;
